export { default } from './SkeletonNewsletter';
